import { ConsentStorePort } from '../../../application/ports/ConsentStorePort';
import { Consent } from '../../../entities/Consent';
import store from '../../../store';
import { setGivenConsents } from '../../../frameworks_drivers/redux/reducers/onboardingInformation/onboardingInformationSlice';

export class ReduxConsentStoreService implements ConsentStorePort {
  addConsent(consent: any): void {
    const state = store.getState();
    const existingConsents = state.onboardingInfo?.givenConsents ?? [];
    const updatedConsents = [...existingConsents, consent];
    store.dispatch(setGivenConsents(updatedConsents));
  }

  getGivenConsents(): Consent[] {
    const state = store.getState();
    return state.onboardingInfo.givenConsents;
  }

  resetGivenConsents(): void {
    store.dispatch(setGivenConsents([]));
  }
}
